const bgColors = {
  lightAzure: "#E7F9FF",
  white: "#FFFFFF",
  darkBlue: "#1F1F75",
  yellow: "#FFB600",
  whatsappGreen: "#32a501",
  azureWhiteGradient:
    "linear-gradient(90deg, rgba(0, 127, 255, 1) 0%, rgba(255, 255, 255, 1) 100%)",
  orangeGradient:
    "linear-gradient(180deg, rgba(237, 114, 47, 0.8), rgba(241, 143, 22, 0.8))",
  azureGradient:
    "linear-gradient(180deg, rgba(32, 183, 199), rgba( 58, 195, 211))",
  darkBlueGradient:
    "linear-gradient(180deg, rgba(0, 65, 140, 1),rgba(0, 83, 160, 1))",
};

export default bgColors;
